// extracted by mini-css-extract-plugin
export default {"Tech":"Tech_Tech__n-aTC","Tech__Image":"Tech_Tech__Image__ogYiS"};